import { TitleEntityForm } from '../../features/TitleEntityForm';
import { apiRequests } from '../../shared/api/apiRequests';

const CreateCategoryOfProductsPage = () => (
  <TitleEntityForm
    create={apiRequests.products.createCategory}
    backTo="/shop/products/categories"
    placeholder="Например, Худи и свитшоты"
    createdText="Категория создана"
  />
);

export default CreateCategoryOfProductsPage;
